import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useFormContext } from "react-hook-form";
import classNames from "classnames";
import ObjectService from "../../Services/Shared/Object.service";
import Checkbox from "../UI/Form/Checkbox";
const CheckboxField = ({ name, label, helpText, className, disabled, title, }) => {
    const { errors, register } = useFormContext();
    const error = React.useMemo(() => ObjectService.getPropertyAtPath(errors, name), [errors, name]);
    return (_jsxs("div", { className: classNames("form-group", className), children: [_jsx(Checkbox, { isInvalid: !!error, invalidMessage: error === null || error === void 0 ? void 0 : error.message, label: label, name: name, ref: register(), disabled: disabled, title: title }), helpText && _jsx("small", { className: "text-muted", children: helpText }), error && _jsx("div", { className: "invalid-feedback", children: error.message })] }));
};
export default CheckboxField;
